module.exports = __webpack_public_path__ + "img/map.0354dc14.png";